import './social_links.less';

import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import classNames from 'classnames';

import { getTracker } from 'zoomforth_codesbane_viewer/lib/global_store.js';

import SocialLinkIcon from 'zoomforth_codesbane_viewer/viewer/header_legacy/social_link_icon.jsx';

const SocialLinks = ({ socialLinks, pullRight, ...props }) => {
  return (
    <div
      className={classNames('modern-header-social-links', {
        'force-right': pullRight,
      })}
      {...props}
    >
      {map(
        socialLinks,
        (link, index) =>
          link.enabled && (
            <div
              key={index}
              className={'header-social-icon-wrapper'}
              data-service-name={link.serviceName}
            >
              <a
                href={`${link.link}`}
                target={link.target || '_blank'}
                className='social-icon-link'
                onClick={(e) => {
                  getTracker().handleSocialIconClick(e);
                }}
              >
                <SocialLinkIcon serviceName={link.serviceName} />
              </a>
            </div>
          )
      )}
    </div>
  );
};

SocialLinks.propTypes = {
  /**
   * List of social links to be displayed in the header
   */
  socialLinks: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * the social app nane
       */
      serviceName: PropTypes.string.isRequired,
      /**
       * Link to social app web profile
       */
      link: PropTypes.string.isRequired,
      /**
       * URL target triggered when clicking on the social icone
       */
      target: PropTypes.oneOf(['_blank', '_parent']),
    })
  ),
  /**
   * Whether to push the container to the right most section of the screen,
   * in the absence of links in the header
   */
  pullRight: PropTypes.bool,
};

export default SocialLinks;
